import React from 'react';
import RecoverableImage from '../images/RecoverableImage';
import { bannerCopy } from './homeBanners';
import './HomeHero.css';

// Shared by the public rail and admin preview. fullCreative describes image
// placement in the app; it does not mean that headline/subtitle are baked in.
export default function HeroCreative({ banner, locale = 'ko', imageAlt = '' }) {
  const config = banner.appConfig || {};
  const { headline, subtitle } = bannerCopy(banner, locale);
  return (
    <div className={`pp-home-hero-art ${config.contentTone === 'dark' ? 'pp-hero-light' : ''}`}>
      {(config.imageUrl || banner.imageUrl) && (
        <RecoverableImage src={config.imageUrl || banner.imageUrl} alt={imageAlt} />
      )}
      {(headline || subtitle) && (
        <div className="pp-home-hero-copy">
          {headline && (
            <strong>
              {config.sourceIcon === 'youtube' && (
                <svg
                  className="pp-home-hero-source"
                  viewBox="0 0 24 17"
                  role="img"
                  aria-label="YouTube"
                  focusable="false"
                >
                  <rect width="24" height="17" rx="5" fill="#ff0033" />
                  <path d="m10 4.5 6.5 4-6.5 4z" fill="#fff" />
                </svg>
              )}
              {headline}
            </strong>
          )}
          {subtitle && <p>{subtitle}</p>}
        </div>
      )}
      {config.showAd && <span className="pp-home-hero-ad">AD</span>}
    </div>
  );
}
